import { ref } from "vue";

export const alertDeleteCustomerMessageHappyEmpty = {
    title: '',
    message: "",
    class: "",
}

export interface IAlertDeleteCustomerMessageHappy {
    title: string;
    message: string;
    class: string;
}

export const alertDeleteCustomerMessageHappy = ref<IAlertDeleteCustomerMessageHappy>(alertDeleteCustomerMessageHappyEmpty)
export const showAlertDeleteCustomerMessageHappy = ref<boolean>(false);